/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CompanyId} from "./companyId.zod";
import {PartyProfileDto} from "./partyProfileDto.zod";

export const RegisteredCompanyDto = zod.object({
  companyId: CompanyId,
  companyName: zod.string(),
  partyProfile: PartyProfileDto,
});

export type RegisteredCompanyDto = zod.input<typeof RegisteredCompanyDto>;
export type RegisteredCompanyDtoOutput = zod.output<typeof RegisteredCompanyDto>;
